import { createContext } from "react";

const TokenContext = createContext("");

export default TokenContext;